import React, { useState, useRef } from 'react'
import { performRequest } from '../../common/utils'
import { HandleShowCloseModal } from '../../common/modal/HandleShowCloseModal'
import Icons from '../../common/icons/Icons'
import { isLink } from '../../pages/groups-dashboard/Members/form/Utils'

const ProcessingCSV = ({ team, uploadCsvResponse, mapCsvResponse, resetFileInput }) => {
    const [ responseStatus, setResponseStatus ] = useState()
    const [ processStarted, setProcessStarted ] = useState(false)
    const [ progressBarInfo, setProgressBarInfo ] = useState({
        percentage: 0,
        title: 'Processing',
        message: `Your CSV is being imported.`,
    })
    const circleRef = useRef()

    const handleImportAnotherCsv = () => {
        resetFileInput()
        setResponseStatus()
        setProcessStarted(false)
        setProgressBarInfo({
            percentage: 0,
            title: 'Processing',
            message: `Your CSV is being imported.`,
        })
        HandleShowCloseModal('msync-upload-csv-modal', 'msync-modal-processing-import')
    }

    const changeProgressBar = ( resp ) => {
        const [ rowCurrent, allRows ] = resp

        const percent = ( ( rowCurrent / allRows ) * 100 ).toFixed(2)
        const progressCircle = circleRef.current
        
        progressCircle.style.strokeDashoffset = `calc(314px - (314px * ${ percent }) / 100)`

        setProgressBarInfo({
            ...progressBarInfo,
            percentage: percent
        })
        
        const isCompleted = ( rowCurrent === allRows )

        if( isCompleted ) {
            setProgressBarInfo({
                percentage: 100,
                title: 'Done!',
                message: 'Your CSV has been successfully imported. You can now view and manage your members on the Members page.',
            })
            setResponseStatus('done')
        }
    }

    const processRequest = async() => {
        if( !uploadCsvResponse || !mapCsvResponse ){
            setProgressBarInfo({
                ...progressBarInfo,
                title: `Cannot procced`,
                message: 'Cannot process without creating and mapping the CSV!',
            })
            setResponseStatus('failed')
            return
        }
        
        let i = 1
        const formData = new FormData()
        formData.append('action', msyncCsvImport.process)
        formData.append('uid', mapCsvResponse.uid)
        formData.append('nonce', msyncCsvImport.nonce_process)
        formData.append('team_type', team.team_type)
      
        try {
            while ( i <= uploadCsvResponse.rowcount ){

                const request = await performRequest( msyncCsvImport.url, formData )
                const resp = await request.json()

                if( !resp.success ){
                    let respError  = resp.errors[0]
                    if( respError.includes('User is already a member of the team') ){
                        respError = "User is already a member of the team"
                    }
                    throw new Error( respError )
                }
    
                changeProgressBar( resp.progress )
                i++
            }
            
        } catch (error) {

            setProgressBarInfo({
                ...progressBarInfo,
                title: `${error}`,
                message: 'Cannot proceed due to an error.',
            })
            setResponseStatus('failed')
        }
    }

    if( mapCsvResponse && progressBarInfo.percentage === 0 && !processStarted ){
        processRequest()
        setProcessStarted(true)
    }

    return (
        <>
            <main className="msync-modal__body msync-processing-csv">
                <div className="msync-modal-upload-container msync-col">
                    { !responseStatus && (
                        <div className="msync-progress-bar-container">
                            <div className="msync-progress-bar-percent">
                                <svg>
                                    <circle cx="60" cy="60" r="50"></circle>
                                    <circle ref={circleRef} cx="60" cy="60" r="50"></circle>
                                </svg>
                                <div className="msync-progress-bar-number">
                                    <h3 id="msync-progress-percentage">{ progressBarInfo.percentage }%</h3>
                                </div>
                            </div>
                        </div>
                    )}
                    { progressBarInfo.title !== 'Processing' && (
                        <div className={`msync-modal-upload-container msync-center msync-is-completed show`} >
                            { responseStatus && (
                              <Icons type={ responseStatus } width={ 100 } height={ 100 } />
                            ) }
                        </div>
                    )}
                    <div>
                        <h3 className="msync-progress-bar-title">{ progressBarInfo.title }</h3>
                    </div>
                    <p className="msync-progress-message">{ progressBarInfo.message }</p>
                </div>
            </main>
            <footer className="msync-modal__footer">
                <div className={`msync-modal-upload-container msync-row msync-center msync-processing-btns`}>
                    { progressBarInfo.title === 'Processing' && (
                      <>
                        {/* <button type="button" className="msync-button msync-button-md msync-filled-primary-button msync-btn-for-processing" >Close window</button> Add this when the back-end supports the background process*/}
                        <a href={msyncCsvImport.current_url} className="msync-button msync-button-md msync-outline-error-anchor msync-btn-for-processing">Cancel import</a>
                      </>
                    )}
                    { progressBarInfo.title.includes('Error') && (
                      <>
                        {/* <button type="button" className="msync-button msync-button-md msync-outline-error-button msync-btn-for-error">View Error (Log)</button> Add this when the back-end supports the background process*/}
                        <button type="button" className="msync-button msync-button-md msync-filled-primary-button" onClick={handleImportAnotherCsv}>Import Another CSV</button>
                      </>
                    )}
                    { progressBarInfo.title === 'Done!' && (
                      team.teamAreaURL['members'] && isLink( team.teamAreaURL['members'] )
                      ? <a href={ team.teamAreaURL['members'] ?? '#' } className="msync-button msync-button-md msync-filled-primary-anchor">View Members</a>
                      : <button type='button' onClick={ () => window.location.reload(true) } className="msync-button msync-button-md msync-filled-primary-anchor"> View Members </button>
                    )}
                </div>
            </footer>
        </>
    )
}

export default ProcessingCSV
